<app-base-modal
  [title]="'Редактирование блогера'"
>
  <div class="container">
    <form
      [formGroup]="formGroup"
      class="form-container"
    >
      @for (field of formFields; track $index) {
        @if (field.type === 'select') {
          <mat-form-field
            appearance="outline"
            [style.background-color]="getSelectedDataColor(field.fieldName)"
          >
            <mat-label>{{ field.label }}</mat-label>
            <mat-select [formControlName]="field.fieldName">
              <mat-option></mat-option>
              @for (option of getSelectOptions(field.fieldName); track $index) {
                <mat-option
                  [value]="option.id"
                  [style.background-color]="getColorWithOpacity(option.color, 0.35)"
                >
                  {{ option.value }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        } @else {
          <mat-form-field appearance="outline">
            <mat-label>{{ field.label }}</mat-label>
            <input
              matInput
              type="text"
              [formControlName]="field.fieldName"
            >
          </mat-form-field>
        }
      }
    </form>
    <div class="buttons-container">
      <button
        mat-button
        color="primary"
        (click)="handleBloggerUpdate()"
      >
        Сохранить
      </button>
      <button
        mat-button
        color="warn"
        (click)="closeDialog('cancel')"
      >
        Отменить
      </button>
    </div>
  </div>
</app-base-modal>
